import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { UseTranslate } from '../../../hooks/Translate';
import { SideBarUserImage } from '../Icons';

import { AiOutlineUser } from 'react-icons/ai';
import { BsArrowBarRight } from 'react-icons/bs';
import { VscSettingsGear } from 'react-icons/vsc';
type SidebarProps = {
  logOut(): void;
  userInfo: {
    firstName: string;
    lastName: string;
  };
};

function onBackdropClick() {
  const sidebar = document.getElementsByClassName('cas-sidebar')[0];
  sidebar.classList.remove('cas-sidebar--open');
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export default function CasSidebar({ userInfo, logOut }: SidebarProps) {
  const [translate] = UseTranslate();
  const location = useLocation();

  function getNavLinkClass(path: string) {
    return location.pathname.includes(path) ? 'active' : '';
  }

  const { firstName, lastName } = userInfo;

  return (
    <div className="cas-sidebar">
      <div className="cas-sidebar__inner">
        <div className="cas-sidebar__user">
          {SideBarUserImage()}
          <div className="cas-sidebar__user__name">
            <span className="cas-sidebar__user__first-name">{firstName}</span>
            <span className="cas-sidebar__user__last-name">{lastName}</span>
          </div>
        </div>
        <ul className="cas-sidebar__menu">
          <li className={getNavLinkClass('/profile')}>
            <Link to="/profile" onClick={onBackdropClick}>
              <AiOutlineUser size={24} />
              {translate('cas.profile')}
            </Link>
          </li>
          <li className={getNavLinkClass('/change-password')}>
            <Link to="/change-password" onClick={onBackdropClick}>
              <VscSettingsGear size={24} />
              {translate('cas.parameters')}
            </Link>
          </li>
          <li>
            <a
              href="#!"
              onClick={(ev) => {
                ev.preventDefault();
                logOut();
              }}
            >
              <BsArrowBarRight size={24} />
              {translate('cas.logout')}
            </a>
          </li>
        </ul>
      </div>
      <div className="cas-sidebar-backdrop" onClick={onBackdropClick}></div>
    </div>
  );
}
